/**
 * Firestore helpers
 * Placeholder module for database utilities
 */
import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
} from 'firebase/firestore'
import { getFirebaseDb } from './firebase.js'

/**
 * Get a document by ID
 * @param {string} collectionName
 * @param {string} docId
 * @returns {Promise<Object|null>}
 */
export async function getDocument(collectionName, docId) {
  const db = getFirebaseDb()
  const docRef = doc(db, collectionName, docId)
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() }
  }
  return null
}

/**
 * Get all documents in a collection
 * @param {string} collectionName
 * @returns {Promise<Array>}
 */
export async function getCollection(collectionName) {
  const db = getFirebaseDb()
  const querySnapshot = await getDocs(collection(db, collectionName))
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
}

/**
 * Add a new document
 * @param {string} collectionName
 * @param {Object} data
 * @returns {Promise<string>} New document ID
 */
export async function addDocument(collectionName, data) {
  const db = getFirebaseDb()
  const docRef = await addDoc(collection(db, collectionName), data)
  return docRef.id
}

/**
 * Update a document
 * @param {string} collectionName
 * @param {string} docId
 * @param {Object} data
 * @returns {Promise}
 */
export async function updateDocument(collectionName, docId, data) {
  const db = getFirebaseDb()
  const docRef = doc(db, collectionName, docId)
  return updateDoc(docRef, data)
}

/**
 * Delete a document
 * @param {string} collectionName
 * @param {string} docId
 * @returns {Promise}
 */
export async function removeDocument(collectionName, docId) {
  const db = getFirebaseDb()
  const docRef = doc(db, collectionName, docId)
  return deleteDoc(docRef)
}

// Export Firestore query helpers for advanced usage
export { collection, doc, query, where, orderBy, limit }
